module.exports = __webpack_public_path__ + "gPlus.png?54ff662d486f625f6022d9bcbf4a0a9a";